$( document ).ready(function() {
// Get the initial value of the radio input
var initialValue = $('input[name=variant-option-selector]:checked').val();
// Set up a function to run when the radio input changes
var maxQuantity = $('#quantity').data('prod-inv');
$('input[name=variant-option-selector]').change(function() {
  var currentValue = $(this).val();
  if (currentValue !== initialValue) {
    setTimeout(function() {
    console.log(maxQuantity);
    maxQuantity = $('#quantity').data('prod-inv');
    console.log(maxQuantity);
    },100);
    initialValue = currentValue; // Update the initial value to the new value
  }
setTimeout(function() {
  $("#quantity").on("input", function() {
    if ($(this).val() > maxQuantity) {
      $(this).val(maxQuantity);
    }
  });
  maxQuantity = $('#quantity').data('prod-inv');
  if ($('#quantity').val() > maxQuantity) {
    $('#quantity').val(maxQuantity);
  }
  $('.stock-notif').text('Only ' +maxQuantity+ ' left in stock')
},100);
  
});
  $('[data-quantity="down"], [data-quantity="up"]').click(function(){
    maxQuantity = $('#quantity').data('prod-inv');
    $("#quantity").on("change", function() {
      if ($(this).val() > maxQuantity) {
        $(this).val(maxQuantity);
      }
    });
  });

maxQuantity = $('#quantity').data('prod-inv');
  $("#quantity").on("change", function() {
    if ($(this).val() > maxQuantity) {
      $(this).val(maxQuantity);
    }
  });
  $('.submit-btn').click(function(){
    maxQuantity = $('#quantity').data('prod-inv');
    if ($('#quantity').val() > maxQuantity) {
      $('#quantity').val(maxQuantity);
    }
  });
});